import { IconProps } from '@types'

export const MetamaskIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      width="50"
      height="49"
      viewBox="0 0 50 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M47.3394 1.4082L27.9766 15.7892L31.5572 7.30463L47.3394 1.4082Z"
        fill="#E2761B"
        stroke="#E2761B"
        strokeWidth="0.0973007"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.63672 1.4082L21.8439 15.9255L18.4384 7.30463L2.63672 1.4082Z"
        fill="#E4761B"
        stroke="#E4761B"
        strokeWidth="0.0973007"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.3679 34.7441L35.2109 42.645L46.2448 45.6807L49.4168 34.9193L40.3679 34.7441Z"
        fill="#E4761B"
        stroke="#E4761B"
        strokeWidth="0.0973007"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.59375 34.9193L3.74629 45.6807L14.7802 42.645L9.62325 34.7441L0.59375 34.9193Z"
        fill="#E4761B"
        stroke="#E4761B"
        strokeWidth="0.0973007"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.157 21.3937L11.0823 26.0447L22.0383 26.5312L21.6491 14.7578L14.157 21.3937Z"
        fill="#E4761B"
        stroke="#E4761B"
        strokeWidth="0.0973007"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.819 21.3932L28.2295 14.6211L27.9766 26.5307L38.9132 26.0442L35.819 21.3932Z"
        fill="#E4761B"
        stroke="#E4761B"
        strokeWidth="0.0973007"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.7812 42.6439L21.3588 39.433L15.6764 34.9961L14.7812 42.6439Z"
        fill="#E4761B"
        stroke="#E4761B"
        strokeWidth="0.0973007"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.6172 39.433L35.2142 42.6439L34.2996 34.9961L28.6172 39.433Z"
        fill="#E4761B"
        stroke="#E4761B"
        strokeWidth="0.0973007"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.2181 42.6445L28.6211 39.4336L29.1465 43.7343L29.0881 45.5441L35.2181 42.6445Z"
        fill="#D7C1B3"
        stroke="#D7C1B3"
        strokeWidth="0.0973007"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.7852 42.6445L20.9151 45.5441L20.8762 43.7343L21.3627 39.4336L14.7852 42.6445Z"
        fill="#D7C1B3"
        stroke="#D7C1B3"
        strokeWidth="0.0973007"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.0112 32.1556L15.5234 30.5404L19.396 28.7695L21.0112 32.1556Z"
        fill="#233447"
        stroke="#233447"
        strokeWidth="0.0973007"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.9688 32.1556L30.5839 28.7695L34.476 30.5404L28.9688 32.1556Z"
        fill="#233447"
        stroke="#233447"
        strokeWidth="0.0973007"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.7858 42.645L15.7199 34.7441L9.62891 34.9193L14.7858 42.645Z"
        fill="#CD6116"
        stroke="#CD6116"
        strokeWidth="0.0973007"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.2854 34.7441L35.2195 42.645L40.3764 34.9193L34.2854 34.7441Z"
        fill="#CD6116"
        stroke="#CD6116"
        strokeWidth="0.0973007"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.9171 26.0449L27.9805 26.5314L28.9924 32.1554L30.6076 28.7693L34.4996 30.5402L38.9171 26.0449Z"
        fill="#CD6116"
        stroke="#CD6116"
        strokeWidth="0.0973007"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5268 30.5402L19.4188 28.7693L21.0145 32.1554L22.0459 26.5314L11.0898 26.0449L15.5268 30.5402Z"
        fill="#CD6116"
        stroke="#CD6116"
        strokeWidth="0.0973007"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0859 26.0449L15.6785 34.9966L15.5228 30.5402L11.0859 26.0449Z"
        fill="#E4751F"
        stroke="#E4751F"
        strokeWidth="0.0973007"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.4954 30.5402L34.3008 34.9966L38.9128 26.0449L34.4954 30.5402Z"
        fill="#E4751F"
        stroke="#E4751F"
        strokeWidth="0.0973007"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.0431 26.5312L21.0117 32.1552L22.2961 38.7911L22.588 30.0535L22.0431 26.5312Z"
        fill="#E4751F"
        stroke="#E4751F"
        strokeWidth="0.0973007"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.9786 26.5312L27.4531 30.0341L27.6866 38.7911L28.9905 32.1552L27.9786 26.5312Z"
        fill="#E4751F"
        stroke="#E4751F"
        strokeWidth="0.0973007"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.9874 32.1562L27.6836 38.7921L28.6177 39.4343L34.3 34.9974L34.4946 30.541L28.9874 32.1562Z"
        fill="#F6851B"
        stroke="#F6851B"
        strokeWidth="0.0973007"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5234 30.541L15.6791 34.9974L21.3615 39.4343L22.2956 38.7921L21.0112 32.1562L15.5234 30.541Z"
        fill="#F6851B"
        stroke="#F6851B"
        strokeWidth="0.0973007"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.0845 45.5441L29.1428 43.7343L28.6563 43.3062H21.3199L20.8723 43.7343L20.9112 45.5441L14.7812 42.6445L16.9219 44.3959L21.2615 47.4123H28.7147L33.0738 44.3959L35.2144 42.6445L29.0845 45.5441Z"
        fill="#C0AD9E"
        stroke="#C0AD9E"
        strokeWidth="0.0973007"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.6201 39.4332L27.686 38.791H22.2956L21.3615 39.4332L20.875 43.7339L21.3226 43.3058H28.6591L29.1456 43.7339L28.6201 39.4332Z"
        fill="#161616"
        stroke="#161616"
        strokeWidth="0.0973007"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M48.1552 16.7233L49.8093 8.7836L47.3378 1.4082L28.6172 15.3027L35.8174 21.3938L45.9951 24.3712L48.2525 21.744L47.2795 21.0435L48.8363 19.6229L47.6297 18.6888L49.1866 17.5017L48.1552 16.7233Z"
        fill="#763D16"
        stroke="#763D16"
        strokeWidth="0.0973007"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.1875 8.7836L1.84161 16.7233L0.790765 17.5017L2.34758 18.6888L1.16051 19.6229L2.71732 21.0435L1.74431 21.744L3.98223 24.3712L14.1599 21.3938L21.3601 15.3027L2.63948 1.4082L0.1875 8.7836Z"
        fill="#763D16"
        stroke="#763D16"
        strokeWidth="0.0973007"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.9963 24.3719L35.8187 21.3945L38.9128 26.0455L34.3008 34.9972L40.3723 34.9193H49.4213L45.9963 24.3719Z"
        fill="#F6851B"
        stroke="#F6851B"
        strokeWidth="0.0973007"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1614 21.3945L3.98372 24.3719L0.597656 34.9193H9.62716L15.6793 34.9972L11.0867 26.0455L14.1614 21.3945Z"
        fill="#F6851B"
        stroke="#F6851B"
        strokeWidth="0.0973007"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.9769 26.5313L28.6191 15.3028L31.577 7.30469H18.4414L21.3604 15.3028L22.0415 26.5313L22.2751 30.073L22.2945 38.7912H27.685L27.7239 30.073L27.9769 26.5313Z"
        fill="#F6851B"
        stroke="#F6851B"
        strokeWidth="0.0973007"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
